import { mainSiteUrl } from '@/mocks/categories';

const bannerProducts = [
  { src: 'https://readdy.ai/api/search-image?query=Trendy%20sneaker%20isolated%20product%20shot%20on%20clean%20white%20background%2C%20minimalist%20ecommerce%20photography%2C%20soft%20lighting%2C%20sharp%20detail&width=160&height=160&seq=banner-p1-01&orientation=squarish', label: 'Shoes' },
  { src: 'https://readdy.ai/api/search-image?query=Premium%20hoodie%20isolated%20product%20shot%20on%20clean%20white%20background%2C%20minimalist%20ecommerce%20photography%2C%20soft%20lighting%2C%20fabric%20texture%20detail&width=160&height=160&seq=banner-p2-01&orientation=squarish', label: 'Hoodies' },
  { src: 'https://readdy.ai/api/search-image?query=Casual%20t-shirt%20isolated%20product%20shot%20on%20clean%20white%20background%2C%20minimalist%20ecommerce%20photography%2C%20soft%20lighting%2C%20clean%20design&width=160&height=160&seq=banner-p3-01&orientation=squarish', label: 'T-Shirts' },
  { src: 'https://readdy.ai/api/search-image?query=Stylish%20jacket%20isolated%20product%20shot%20on%20clean%20white%20background%2C%20minimalist%20ecommerce%20photography%2C%20soft%20lighting%2C%20detail%20texture&width=160&height=160&seq=banner-p4-01&orientation=squarish', label: 'Jackets' },
  { src: 'https://readdy.ai/api/search-image?query=Designer%20bag%20isolated%20product%20shot%20on%20clean%20white%20background%2C%20minimalist%20ecommerce%20photography%2C%20soft%20lighting%2C%20premium%20look&width=160&height=160&seq=banner-p5-01&orientation=squarish', label: 'Bags' },
  { src: 'https://readdy.ai/api/search-image?query=Fashion%20cap%20isolated%20product%20shot%20on%20clean%20white%20background%2C%20minimalist%20ecommerce%20photography%2C%20soft%20lighting%2C%20clean%20design&width=160&height=160&seq=banner-p6-01&orientation=squarish', label: 'Headwear' },
  { src: 'https://readdy.ai/api/search-image?query=Elegant%20watch%20isolated%20product%20shot%20on%20clean%20white%20background%2C%20minimalist%20ecommerce%20photography%2C%20soft%20lighting%2C%20premium%20style&width=160&height=160&seq=banner-p7-01&orientation=squarish', label: 'Accessories' },
  { src: 'https://readdy.ai/api/search-image?query=Luxury%20perfume%20bottle%20isolated%20product%20shot%20on%20clean%20white%20background%2C%20minimalist%20beauty%20photography%2C%20soft%20lighting%2C%20elegant%20styling&width=160&height=160&seq=banner-p8-01&orientation=squarish', label: 'Perfumes' },
];

export default function VisualBanner() {
  return (
    <section className="relative bg-white py-12 md:py-16 overflow-hidden">
      {/* Scrolling marquee of product images */}
      <div className="w-full">
        <div className="flex items-center gap-3 md:gap-4 px-6 lg:px-10 mb-6">
          <span className="text-xs font-semibold uppercase tracking-widest text-stone-400 shrink-0">
            Популярные категории
          </span>
          <div className="h-px flex-1 bg-stone-200" />
        </div>

        <div className="flex gap-3 md:gap-4 overflow-x-auto px-6 lg:px-10 pb-2 scrollbar-hide snap-x snap-mandatory">
          {bannerProducts.map((item, i) => (
            <a
              key={i}
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="flex flex-col items-center gap-2 shrink-0 snap-start group"
            >
              <div className="w-20 h-20 md:w-24 md:h-24 rounded-2xl overflow-hidden bg-stone-100 group-hover:ring-2 group-hover:ring-stone-300 transition-all duration-300 group-hover:scale-105">
                <img
                  src={item.src}
                  alt={item.label}
                  className="w-full h-full object-cover"
                />
              </div>
              <span className="text-xs text-stone-500 font-medium group-hover:text-stone-900 transition-colors">
                {item.label}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}